// Collections
export const TEMPLATES_COLLECTION = "templates";
export const DESCRIPTIONS_COLLECTION = "descriptions";
export const GROUPS_COLLECTION = "groups";
export const TASKS_COLLECTION = "tasks";
export const USERS_COLLECTION = "users";
export const CONTEXTS_COLLECTION = "contexts";
export const ITEMS_COLLECTIONS = "items";
export const NOTES_COLLECTIONS = "notes";
export const MESSAGES_COLLECTIONS = "messages";
export const COMMENTS_COLLECTIONS = "comments";
export const SUGGESTIONS_COLLECTION = "suggestions";
export const NOTIFICATIONS_COLLECTION = "notifications";

// Fields
export const TASK_RESPONSIBLE = "responsible";
export const NOTIFICATION_OWNER = "owner";

export const GET_TASKS_COLLECTION = (group_id) => `${GROUPS_COLLECTION}/${group_id}/${TASKS_COLLECTION}`;

export const TEMPLATE_DEFAULT = "default";